( function($) {

	var app = {

        initFunctions: function() {

            if( window.location.href.indexOf('/pages/bikes') > -1 && jQuery('.ip-bikes-product-main > .ip-bikes-product-item').length > 0 ) {

                jQuery('.ip-bikes-product-main > .ip-bikes-product-item').each(function(){

                    var this_bike = jQuery(this);

                    if( this_bike.find('.ip-bikes-product-colors .color-options > button').length > 0 ) {
        
                        this_bike.find('.ip-bikes-product-img .featured-image').remove();

                        var get_color = this_bike.find('.bike-img.variant-image.active').attr('data-color');

                        jQuery('.ip-bikes-product-colors .color-options button.' + get_color).addClass('active');
                      
                    } else {
        
                        jQuery(this).find('.ip-bikes-product-img .variant-image').remove();

                        jQuery(this).find('.ip-bikes-product-img .featured-image').addClass('active');
                    }
                });
            }
        }
	}

	
	$(document).ready( function() {
        app.initFunctions();
	});
	
	$(window).on('load', function(){

	});

})(jQuery);